import * as signalR from '@microsoft/signalr'

const baseApi = process.env.VUE_APP_BASE_API.replace(/\/api\/?$/, '')
const apiKey = process.env.VUE_APP_API_SECRETKEY_API   

export const connection = new signalR.HubConnectionBuilder()
  .withUrl(`${baseApi}/hubs/pagos?apikey=${encodeURIComponent(apiKey)}`, {
    accessTokenFactory: () => localStorage.getItem('token'),
    transport: signalR.HttpTransportType.WebSockets
  })
  .withAutomaticReconnect()
  .build()

let inicio = null
export function conectar() {
  if (!inicio) inicio = connection.start()
  return inicio
}